import { useFormContext } from 'react-hook-form'

import {
  FormControl,
  FormError,
  FormField,
  FormItem,
  FormLabel,
  Input,
  SearchSelect,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@fortem-monorepo/react-ui'

import type { StrategyValues } from './strategy-values.schema'

export const StrategyNameField = () => {
  const { control } = useFormContext<StrategyValues>()
  return (
    <FormField
      control={control}
      name="strategy_name"
      render={({ field }) => (
        <FormItem>
          <div className="flex items-center gap-2">
            <FormLabel>Strategy name</FormLabel>
            <FormError />
          </div>
          <FormControl>
            <Input inputSize="sm" maxLength={100} {...field} />
          </FormControl>
        </FormItem>
      )}
    />
  )
}

export const StrategyBooleanFields = ({ disabled }: { disabled: boolean }) => {
  const { control } = useFormContext<StrategyValues>()
  return (
    <>
      <FormField
        control={control}
        name="is_internal"
        render={({ field }) => (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Management</FormLabel>
              <FormError />
            </div>
            <Select value={field.value ?? ''} onValueChange={field.onChange} disabled={disabled}>
              <FormControl>
                <SelectTrigger size="sm" ref={field.ref} onBlur={field.onBlur}>
                  <SelectValue placeholder="Select management" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="true">INTERNAL</SelectItem>
                <SelectItem value="false">EXTERNAL</SelectItem>
              </SelectContent>
            </Select>
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name="active"
        render={({ field }) => (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Status</FormLabel>
              <FormError />
            </div>
            <Select value={field.value ?? ''} onValueChange={field.onChange} disabled={disabled}>
              <FormControl>
                <SelectTrigger size="sm" ref={field.ref} onBlur={field.onBlur}>
                  <SelectValue placeholder="Select a status" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="true">ACTIVE</SelectItem>
                <SelectItem value="false">INACTIVE</SelectItem>
              </SelectContent>
            </Select>
          </FormItem>
        )}
      />
    </>
  )
}

export const StrategyTypeField = ({ strategyTypes, disabled }: { strategyTypes: string[]; disabled: boolean }) => {
  const { control } = useFormContext<StrategyValues>()

  return (
    <FormField
      control={control}
      name="strategy_type"
      render={({ field }) => (
        <FormItem>
          <div className="flex items-center gap-2">
            <FormLabel>Strategy type</FormLabel>
            <FormError />
          </div>
          <FormControl>
            <SearchSelect
              size="sm"
              placeholder="Select a strategy type"
              name={field.name}
              value={field.value}
              setValue={field.onChange}
              onBlur={field.onBlur}
              ref={field.ref}
              disabled={disabled}
              options={strategyTypes.filter(Boolean).map((type) => ({ label: type, value: type }))}
            />
          </FormControl>
        </FormItem>
      )}
    />
  )
}
